import React from "react";
import Paper from "material-ui/Paper";
import Grid from "material-ui/Grid";
import Typography from "material-ui/Typography";
import Card, { CardContent } from "material-ui/Card";
import { withStyles } from "material-ui/styles";
import {
  metersToFeet,
  getFormattedNumber,
  getWiremapImageUrl
} from "../../../../../../common/utils";
import { infoData, infoData2 } from "./infoenum";
import styles from "./styles";

class QualificationSubtest extends React.Component {
  constructor(props) {
    super(props);
  }

  lengthUnitConverter = length => {
    const { chartMeasurementUnit } = this.props;
    if (chartMeasurementUnit === "feet") {
      return metersToFeet(length);
    }
    return getFormattedNumber(length);
  };

  render() {
    const {
      classes,
      translate,
      results,
      chartMeasurementUnit,
      subtestResultsDisplay,
      subtest,
      subtestRes
    } = this.props;

    let measurementUnit = chartMeasurementUnit === 'feet' ? 'ft' : 'm';
    let wiremapImage = getWiremapImageUrl(results.data.subtests["wiremap"], chartMeasurementUnit);
    let qualificationImage = results.data.subtests["qualification"] ?  results.data.subtests["qualification"].imageurl : null;
    let haveQualificationImage = qualificationImage && (qualificationImage.length > 0);
    let infoString = results.data.subtests[subtest] && results.data.subtests[subtest].info ?
     translate(infoData.find(
        o => o.name === results.data.subtests[subtest].info
      ).id) : "-";

    infoString = infoString.split(" (")[0]; // truncate any text in parenthesis to ensure text fits on the tile in one line
    return (
      <Grid container spacing={0}>
        <div className={classes.imageContainer}>
          {wiremapImage && (
              <img
                alt=""
                src={wiremapImage}
                className={haveQualificationImage ? classes.image : classes.image3}
              />
            )}
          {qualificationImage && (
              <img
                alt=""
                src={qualificationImage}
                className={classes.image2}
              />
            )}
        </div>
        <Grid size="auto" className={haveQualificationImage ? classes.info_div : classes.info_div_without_speed}>
          <Typography color="inherit" className={classes.info}>
            {translate("info") + ": " + infoString}
          </Typography>
        </Grid>
        <Grid size="auto" className={haveQualificationImage ? classes.info_div : classes.info_div_without_speed}>
          <Typography color="inherit" className={classes.info}>
            {translate("Length") + ": " +
            this.lengthUnitConverter(results.data.subtests["wiremap"].length) + " " + measurementUnit}
          </Typography>
        </Grid>
      </Grid>
    );
  }
}

export default withStyles(styles)(QualificationSubtest);



// WEBPACK FOOTER //
// ./src/components/common/results/thumbnails/views/qualificationtest/index.js